import React, { useEffect } from 'react';
import renderCalendar from '../../scripts/renderCalendar';

const Month = ({ date }) => {
  const month = date.getMonth();
  useEffect(() => {
    renderCalendar(date, month);
  }, [date])
  return ( 
    <div className="calendar-month">
      <div className="month" id={`month-${month}`}>
        <h1></h1>
      </div>
      <div className="weekdays">
        <div>Mon</div>
        <div>Tue</div>
        <div>Wed</div>
        <div>Thu</div>
        <div>Fri</div>
        <div className="weekend">Sat</div>
        <div className="weekend">Sun</div>
      </div>
      <div className="days" id={`days-${month}`}></div>
    </div>
  );
}
 
export default Month;